import {FormGroup, ValidationErrors, ValidatorFn} from "@angular/forms";
import {isBeforeOrNull, isInPast} from "../../../../../umbrella-common/date-functions";
import {sanitizeDate} from "../../../../../umbrella-common/common-functions";

export class InitialCertificationDatesValidators {

	static preAuditDateValidator(form: FormGroup, formKey: string): ValidatorFn {
		return control => {
			const dates: Dates = {
				preAuditDate: sanitizeDate(new Date(control.value)),
				stage1AuditDate: sanitizeDate(new Date(form.get('stage1AuditDate' + formKey).value)),
				stage2AuditDate: sanitizeDate(new Date(form.get('stage2AuditDate' + formKey).value))
			};

			return this.validatePreAuditDate(dates);
		};
	}

	static stage1AuditDateValidator(form: FormGroup, formKey: string): ValidatorFn {
		return control => {
			const dates: Dates = {
				preAuditDate: sanitizeDate(new Date(form.get('preAuditDate' + formKey).value)),
				stage1AuditDate: sanitizeDate(new Date(control.value)),
				stage2AuditDate: sanitizeDate(new Date(form.get('stage2AuditDate' + formKey).value))
			};

			return this.validateStage1AuditDate(dates);
		};
	}

	static stage2AuditDateValidator(form: FormGroup, formKey: string): ValidatorFn {
		return control => {
			const dates: Dates = {
				preAuditDate: sanitizeDate(new Date(form.get('preAuditDate' + formKey).value)),
				stage1AuditDate: sanitizeDate(new Date(form.get('stage1AuditDate' + formKey).value)),
				stage2AuditDate: sanitizeDate(new Date(control.value))
			};

			return this.validateStage2AuditDate(dates);
		};
	}

	private static validatePreAuditDate(dates: Dates): ValidationErrors | null {
		const dateInPast: boolean = isInPast(dates.preAuditDate);
		const preAuditBeforeStage1: boolean = isBeforeOrNull(dates.preAuditDate, dates.stage1AuditDate);
		const preAuditBeforeStage2: boolean = isBeforeOrNull(dates.preAuditDate, dates.stage2AuditDate);

		if (preAuditBeforeStage1 && preAuditBeforeStage2 && !dateInPast) {
			return null;
		} else {
			let errors: ValidationErrors = dateInPast ? {preAuditInPast: []} : {};

			if (!preAuditBeforeStage1) {
				errors = Object.assign(errors, {preAuditBeforeStage1: []});
			}

			if (!preAuditBeforeStage2 && preAuditBeforeStage1) {
				errors = Object.assign(errors, {preAuditBeforeStage2: []});
			}

			return errors;
		}
	}

	private static validateStage1AuditDate(dates: Dates): ValidationErrors | null {
		const dateInPast = isInPast(dates.stage1AuditDate);
		const stage1BeforeStage2: boolean = isBeforeOrNull(dates.stage1AuditDate, dates.stage2AuditDate);
		const stage1AfterPreAudit: boolean = isBeforeOrNull(dates.preAuditDate, dates.stage1AuditDate);

		if (stage1BeforeStage2 && stage1AfterPreAudit && !dateInPast) {
			return null;
		} else {
			let errors: ValidationErrors = dateInPast ? {stage1InPast: []} : {};

			if (!stage1AfterPreAudit) {
				errors = Object.assign(errors, {stage1AfterPreAudit: []});
			}

			if (!stage1BeforeStage2) {
				errors = Object.assign(errors, {stage1BeforeStage2: []});
			}

			return errors;
		}
	}

	private static validateStage2AuditDate(dates: Dates): ValidationErrors | null {
		const dateInPast: boolean = isInPast(dates.stage2AuditDate);
		const stage2AfterPreAudit: boolean = isBeforeOrNull(dates.preAuditDate, dates.stage2AuditDate);
		const stage2AfterStage1: boolean = isBeforeOrNull(dates.stage1AuditDate, dates.stage2AuditDate);

		if (stage2AfterPreAudit && stage2AfterStage1 && !dateInPast) {
			return null;
		} else {
			let errors: ValidationErrors = dateInPast ? {stage2InPast: []} : {};

			if (!stage2AfterPreAudit) {
				errors = Object.assign(errors, {stage2AfterPreAudit: []});
			}

			if (!stage2AfterStage1) {
				errors = Object.assign(errors, {stage2AfterStage1: []});
			}

			return errors;
		}
	}

}

interface Dates {
	preAuditDate: Date;
	stage1AuditDate: Date;
	stage2AuditDate: Date;
}
